import { type ReactNode } from 'react'
import cx from 'classnames'
import styles from './AccountSubviewMainContent.module.css'

export interface AccountSubviewMainContentProps {
  children?: ReactNode
}

/**
 * The AccountSubviewMainContent
 */
export function AccountSubviewMainContent({
  children,
}: AccountSubviewMainContentProps) {
  return <main className={cx(styles.root)}>{children}</main>
}
